import React, { Component } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import swal from 'sweetalert2';
import i18n from "i18next";

class AllActionButtons extends Component {
  constructor(props) {
    super(props);

    this.approveSelected = this.approveSelected.bind(this);
    this.allSelected = this.allSelected.bind(this);
    this.transferSelected = this.transferSelected.bind(this);
    this.transferAllButton = this.transferAllButton.bind(this);
    this.allTransferSelected = this.allTransferSelected.bind(this);

    this.state = {
      allSelected: true,
      page: this.props.pageCount,
      requestStatus: props.requestStatus
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ requestStatus: nextProps.requestStatus });
  }

  async approveSelected() {
    const { requestStore, actionButtonEvents } = this.props;
    const { selectedRequests } = requestStore;
    const accountingFilter = selectedRequests.filter(r => r.selected && r.harcirah[0] && (r.harcirah[0].status === 'accounting'));

    if (accountingFilter && accountingFilter.length > 0) {
      accountingFilter.forEach((request) => {
        if (request && request.harcirah && request.harcirah.length > 0) {
          request.harcirah.forEach((harcirah) => {
            actionButtonEvents.approveRequest({
              harcirahId: harcirah._id,
              isAbroad: harcirah.hasOwnProperty("abroad"),
              exchangeRate: harcirah.exchangeRate,
              currency: harcirah.calculatedAmount.abroadCurrency
            });
          });
        }
      });
      setTimeout(() => { actionButtonEvents.renderPage(); }, 3500);
    }

    const filteredList = selectedRequests.filter(r => r.selected && r.harcirah[0] && (r.harcirah[0].status === 'pending'));

    if (filteredList && filteredList.length > 0) {
      filteredList.forEach((request) => {
        if (request && request.harcirah && request.harcirah.length > 0) {
          request.harcirah.forEach((harcirah) => {
            actionButtonEvents.approveRequest({
              harcirahId: harcirah._id,
              exchangeRate: harcirah.exchangeRate,
              currency: harcirah.calculatedAmount.abroadCurrency
            });
          });
        }
      });
      setTimeout(() => { actionButtonEvents.renderPage(); }, 3500);
    }
  }

  async transferSelected() {
    const { requestStore } = this.props;

    if (requestStore && requestStore.length > 0) {
      const filteredList = requestStore.filter(r => r.selected);
      this.props.transferSelected(filteredList);
    }

  }

  async transferAllButton() {
    const { requestStore, transferAll } = this.props;
    if (requestStore && requestStore.length > 0) {
      swal({
        title: 'Onaylıyor musunuz ?',
        text: "Seçilen aydaki tüm harcırahlar puantaja aktarılacaktır!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Evet',
        cancelButtonText: 'iptal',
      }).then(function () {
        setTimeout(function(){
          transferAll(requestStore[0].month, requestStore[0].year);
        }, 500);
      }).catch((e) => {
        console.log(e)
      });
    }
  }

  async allTransferSelected() {
    const { requestStore, selectRequest, pageCount } = this.props;

    this.setState({ allSelected: !this.state.allSelected, page: pageCount });
    requestStore.slice((pageCount - 1) * 10, (pageCount * 10) - 1);
    requestStore.map(request => selectRequest(!this.state.allSelected, request.employmentId, pageCount));
  }
 
  async allSelected() {
    const { requestStore, selectRequest, pageCount } = this.props;
    const { selectedRequests } = requestStore;

    this.setState({ allSelected: !this.state.allSelected, page: pageCount });
    selectedRequests.slice((pageCount - 1) * 10, (pageCount * 10) - 1);
    selectedRequests.map(request => selectRequest(!this.state.allSelected, request.group_id, pageCount));
  }

  render() {
    const { isHr } = this.props;

    return (
      <div id="action-buttons">
        {
            isHr
              ? (
                <ButtonGroup>
                  <Button className="btn-fill btn-danger" onClick={this.transferAllButton}>
                    <i className="fa fa-check fa-lg" />
                    {i18n.t('transferAllPayroll')}
                  </Button>
                  <Button className="btn-fill btn-primary transferSelectedPuantaj" onClick={this.transferSelected}>
                    <i className="fa fa-check fa-lg" />
                    {i18n.t('transferChosenPayrolls')}
                  </Button>
                  <Button className="btn-fill btn-success chooseAll" onClick={this.allTransferSelected}>
                    <i className="fa fa-check-circle fa-lg" />
                    {i18n.t('allChoseNonChoose')}
                  </Button>
                </ButtonGroup>
              )
              : (
                <ButtonGroup>
                  <Button className="btn-fill btn-primary confirmSelected" onClick={this.approveSelected}>
                    <i className="fa fa-check fa-lg" />
                    {i18n.t('approveChosen')}
                  </Button>

                  <Button className="btn-fill btn-success chooseAll1" onClick={this.allSelected}>
                    <i className="fa fa-check-circle fa-lg" />
                    {i18n.t('allChoseNonChoose')}
                  </Button>
                </ButtonGroup>
              )
          }
      </div>
    );
  }
}

export default AllActionButtons;



// WEBPACK FOOTER //
// ./src/components/actions/all/index.js